import React from 'react';
import { ProviderDocument, ProviderDocumentType } from '@uplift/api';
import { CollaborativeAgreementSignedListItem } from './CollaborativeAgreementSignedListItem';
import { CollaborativeAgreementUnsignedListItem } from './CollaborativeAgreementUnsignedListItem';
import { CollaborativeAgreementCounterSignatureRequiredListItem } from './CollaborativeAgreementCounterSignatureRequiredListItem';
import { CollaborativeAgreementCounterSignedListItem } from './CollaborativeAgreementCounterSignedListItem';


export const DocumentListItem: React.VFC<{
  document: ProviderDocument;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  switch (document.type) {
    case ProviderDocumentType.collaborativeAgreementUnsigned:
      return (
        <CollaborativeAgreementUnsignedListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.collaborativeAgreement:
      return (
        <CollaborativeAgreementSignedListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.collaborativeAgreementCounterSignatureRequired:
      return (
        <CollaborativeAgreementCounterSignatureRequiredListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.collaborativeAgreementCounterSigned:
      return (
        <CollaborativeAgreementCounterSignedListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    default:
      return null;
  }
};
